import createPlotlyComponent from "react-plotly.js/factory";
// @ts-ignore - plotly.js-dist-min provides pre-built browser bundle without Node.js deps
import Plotly from "plotly.js-dist-min";
import { Box } from "@mui/material";
import { plotlyLayout, CHART_COLORS } from "../theme";

const Plot = createPlotlyComponent(Plotly);

interface PlotlyChartProps {
  data: any[];
  layout?: Record<string, any>;
  height?: number;
}

const PlotlyChart = ({ data, layout, height = 320 }: PlotlyChartProps) => {
  // Apply Toyota theme colors to traces that don't already have color set
  const themedData = data.map((trace: any, i: number) => ({
    ...trace,
    marker: {
      color: CHART_COLORS[i % CHART_COLORS.length],
      ...trace.marker,
    },
  }));

  return (
    <Box sx={{ width: "100%", "& .js-plotly-plot": { width: "100% !important" } }}>
      <Plot
        data={themedData}
        layout={{
          ...plotlyLayout,
          height,
          autosize: true,
          xaxis: { ...plotlyLayout.xaxis, ...layout?.xaxis },
          yaxis: { ...plotlyLayout.yaxis, ...layout?.yaxis },
          ...layout,
          margin: { ...plotlyLayout.margin, ...layout?.margin },
        }}
        config={{ displayModeBar: false, responsive: true }}
        useResizeHandler
        style={{ width: "100%" }}
      />
    </Box>
  );
};

export default PlotlyChart;
